<template>
  <div>
    <!-- Type / Level selectors + Duplicate -->
    <div class="row">
      <div class="col-md-4">
        <label class="d-block">{{ $t("etablissement.type") }}</label>
        <a-select
          size="large"
          class="w-100"
          :value="selectedType"
          @change="selectedType = $event"
        >
          <a-select-option
            v-for="(value, key) in bulletinTypesNames"
            :key="key"
            :value="key"
          >
            {{ value }}
          </a-select-option>
        </a-select>
      </div>
      <div class="col-md-3">
        <label class="d-block">{{ $t("etablissement.niveau") }}</label>
        <a-select
          size="large"
          class="w-100"
          :value="selectedLevel"
          @change="selectedLevel = $event"
        >
          <a-select-option
            v-for="(value, name) in levelSelectData"
            :key="name"
            :value="name"
          >
            {{ value }}
          </a-select-option>
        </a-select>
      </div>
      <div class="col-md-5 d-flex align-items-end justify-content-end">
        <a-button
          type="primary"
          :disabled="isReadOnly"
          @click="visibleClone = true"
        >
          {{ $t("bulletin.duplicateSettings") }}
        </a-button>
      </div>
    </div>

    <a-spin :spinning="loading">
      <!-- Display options config -->
      <a-card class="mt-3" :title="$t('bulletin.displayOptions')">
        <div class="row">
          <div class="col-md-6 d-flex align-items-center mb-3">
            <label class="mb-0 mr-3 flex-grow-1">{{
              $t("bulletin.PersonalizedAverage")
            }}</label>
            <a-switch
              v-model="config.usePersonalizedAverage"
              :disabled="isReadOnly"
            />
          </div>
          <div class="col-md-6 d-flex align-items-center mb-3">
            <label class="mb-0 mr-3 flex-grow-1">{{
              $t("bulletin.showNbrStudents")
            }}</label>
            <a-switch
              v-model="config.showNbrStudents"
              :disabled="isReadOnly"
            />
          </div>
          <div class="col-md-6 d-flex align-items-center mb-3">
            <label class="mb-0 mr-3 flex-grow-1">{{
              $t("bulletin.showStamp")
            }}</label>
            <a-switch v-model="config.showStamp" :disabled="isReadOnly" />
          </div>
          <div
            v-if="config.showStamp"
            class="col-md-6 d-flex align-items-center mb-3"
          >
            <label class="mb-0 mr-3 flex-grow-1">{{
              $t("certification.stampScale")
            }}</label>
            <a-input-number
              v-model="config.stampScale"
              :min="0.1"
              :max="3"
              :step="0.1"
              :disabled="isReadOnly"
            />
          </div>
          <div class="col-md-6 d-flex align-items-center mb-3">
            <label class="mb-0 mr-3 flex-grow-1">{{
              $t("bulletin.showDate")
            }}</label>
            <a-switch v-model="config.showDate" :disabled="isReadOnly" />
          </div>
          <div class="col-md-6 d-flex align-items-center mb-3">
            <label class="mb-0 mr-3 flex-grow-1">{{
              $t("liste.identifiantUnique")
            }}</label>
            <a-switch v-model="config.showUniqueIDen" :disabled="isReadOnly" />
          </div>          
        </div>
        <div class="text-right">
          <a-button
            type="primary"
            :loading="saving"
            :disabled="isReadOnly"
            @click="saveConfig"
          >
            <a-icon type="check" /> {{ $t("enregistrer") }}
          </a-button>
        </div>
      </a-card>

      <!-- Teachers per classroom -->
      <a-card class="mt-3" :title="$t('bulletin.teachersByClassroom')">
        <div class="row">
          <div class="col-md-5 mb-2">
            <label class="d-block">{{ $t("bulletin.listeClasses") }}</label>
            <a-select
              show-search
              option-filter-prop="children"
              class="w-100"
              :value="selectedClassroom || undefined"
              :placeholder="$t('bulletin.listeClasses')"
              :loading="classroomsLoading"
              @change="handleClassroomChange"
            >
              <a-select-option
                v-for="classe in levelClassrooms"
                :key="classe._id"
                :value="classe._id"
              >
                {{ classe.name }}
              </a-select-option>
            </a-select>
          </div>
          <div class="col-md-7 mb-2" v-if="selectedClassroom">
            <label class="d-block">{{ $t("emploi.listeEnseignants") }}</label>
            <a-select
              mode="multiple"
              class="w-100"
              option-filter-prop="children"
              :value="selectedTeachers"
              :loading="teachersLoading"
              :placeholder="$t('emploi.listeEnseignants')"
              @change="selectedTeachers = $event"
            >
              <a-select-option
                v-for="teacher in classroomTeachers"
                :key="teacher._id"
                :value="teacher._id"
              >
                {{ teacher.fullName }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="text-right" v-if="selectedClassroom">
          <a-button
            type="primary"
            :loading="savingTeachers"
            :disabled="isReadOnly"
            @click="saveTeachers"
          >
            <a-icon type="check" /> {{ $t("enregistrer") }}
          </a-button>
        </div>
      </a-card>
    </a-spin>

    <annual-report-clone
      :visible="visibleClone"
      :levels="levelSelectData"
      :bulletinTypesNames="bulletinTypesNames"
      @hide="visibleClone = false"
      @cloneHappened="onCloneHappened"
    />
  </div>
</template>

<script>
/*eslint-disable*/
import apiClient from "@/services/axios";
import { mapState, mapGetters } from "vuex";
import { getLevels, getDefaultLevel } from "@/config/LevelConstants";
import AnnualReportClone from "./AnnualReportClone.vue";

export default {
  name: "annualReport",
  components: { AnnualReportClone },
  data() {
    return {
      schoolType: null,
      selectedType: "MP",
      selectedLevel: "1",
      loading: false,
      saving: false,
      config: {
        usePersonalizedAverage: false,
        showNbrStudents: true,
        showStamp: true,
        stampScale: 1,
        showDate: true,
        showUniqueIDen:false
      },
      // teachers section
      levelClassrooms: [],
      classroomsLoading: false,
      selectedClassroom: null,
      classroomTeachers: [],
      teachersLoading: false,
      selectedTeachers: [],
      savingTeachers: false,
      visibleClone: false,
    };
  },
  computed: {
    ...mapState(["settings", "user"]),
    ...mapGetters("settings", ["packDetailsGetter"]),
    activeBuilding() {
      return this.user.building.find(
        (el) => el.dbName == this.settings.activeBuilding
      );
    },
    countryCode() {
      return this.activeBuilding?.countryCode;
    },
    levelSelectData() {
      const all = getLevels(this.$t.bind(this), this.schoolType, this.countryCode);
      // Annual report config is capped to levels -2 .. 6 (inclusive)
      return Object.keys(all)
        .filter((key) => Number(key) >= -2 && Number(key) <= 6)
        .reduce((acc, key) => {
          acc[key] = all[key];
          return acc;
        }, {});
    },
    bulletinTypesNames() {
      return {
        MP: this.$t("bulletin.bulletinPedagogique"),
        MT: this.$t("bulletin.bulletinSpecifique"),
        MS: this.$t("bulletin.bulletinVerySpecifique"),
      };
    },
    isReadOnly() {
      const value = this.packDetailsGetter?.access?.edManager?.displaySettings;
      return value === "ro";
    },
  },
  created() {
    this.schoolType = this.activeBuilding?.type;
    // Clamp the default level into the allowed -2 .. 6 range
    const levelKeys = Object.keys(this.levelSelectData);
    let defaultLevel = String(
      getDefaultLevel(this.schoolType, this.countryCode)
    );
    if (!levelKeys.includes(defaultLevel)) {
      defaultLevel = levelKeys[0] || "1";
    }
    this.selectedLevel = defaultLevel;
    this.fetchConfig();
    this.fetchLevelClassrooms();
  },
  watch: {
    selectedType() {
      this.fetchConfig();
    },
    selectedLevel() {
      this.fetchConfig();
      this.fetchLevelClassrooms();
      this.selectedClassroom = null;
      this.selectedTeachers = [];
      this.classroomTeachers = [];
    },
  },
  methods: {
    async fetchConfig() {
      if (!this.selectedType || this.selectedLevel === null) return;
      this.loading = true;
      try {
        const { data } = await apiClient.get(
          `/bulletin/v2/annual-report-config/${this.selectedType}/${this.selectedLevel}`
        );
        this.config = {
          usePersonalizedAverage: !!data.usePersonalizedAverage,
          showNbrStudents: data.showNbrStudents !== false,
          showStamp: data.showStamp !== false,
          stampScale: data.stampScale ?? 1,
          showDate: data.showDate !== false,
          showUniqueIDen: (data.showUniqueIDen != null || data.showUniqueIDen != undefined) && data.showUniqueIDen !== false
        };
      } catch (e) {
        console.error(e);
        this.$message.error(this.$t("error.erreur"));
      } finally {
        this.loading = false;
      }
    },
    async saveConfig() {
      this.saving = true;
      try {
        await apiClient.put("/bulletin/v2/annual-report-config", {
          type: this.selectedType,
          level: Number(this.selectedLevel),
          ...this.config,
        });
        this.$message.success(this.$t("bulletin.configSaved"));
      } catch (e) {
        console.error(e);
        this.$message.error(this.$t("error.erreur"));
      } finally {
        this.saving = false;
      }
    },
    async fetchLevelClassrooms() {
      this.classroomsLoading = true;
      try {
        const { data } = await apiClient.post("/classrooms/filter", {
          query: {
            status: "active",
            level: Number(this.selectedLevel),
          },
          aggregation: {
            $project: { _id: 1, name: 1, level: 1 },
          },
        });
        this.levelClassrooms = data;
      } catch (e) {
        console.error(e);
        this.levelClassrooms = [];
      } finally {
        this.classroomsLoading = false;
      }
    },
    async handleClassroomChange(classroomId) {
      this.selectedClassroom = classroomId;
      this.selectedTeachers = [];
      this.classroomTeachers = [];
      this.teachersLoading = true;
      try {
        // candidate teachers (those with access to this classroom) + saved selection
        const [teachersRes, selectionRes] = await Promise.all([
          apiClient.get(`/teacherAccess/3`),
          apiClient.get(
            `/bulletin/v2/annual-teacher-selection/${classroomId}`
          ),
        ]);
        this.classroomTeachers = teachersRes.data.filter((teacher) =>
          teacher.access.some(
            (accessItem) => accessItem.classeRoom._id === classroomId
          )
        );
        if (selectionRes.data && selectionRes.data.teachers) {
          this.selectedTeachers = selectionRes.data.teachers.map((t) =>
            typeof t === "object" ? t._id || t : t
          );
        }
      } catch (e) {
        console.error(e);
        this.classroomTeachers = [];
      } finally {
        this.teachersLoading = false;
      }
    },
    async saveTeachers() {
      this.savingTeachers = true;
      try {
        await apiClient.put("/bulletin/v2/annual-teacher-selection", {
          classRoom: this.selectedClassroom,
          teachers: this.selectedTeachers,
        });
        this.$message.success(this.$t("bulletin.configSaved"));
      } catch (e) {
        console.error(e);
        this.$message.error(this.$t("error.erreur"));
      } finally {
        this.savingTeachers = false;
      }
    },
    onCloneHappened() {
      this.visibleClone = false;
      this.fetchConfig();
    },
  },
};
</script>

<style scoped></style>
